import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-widget-library',
	styleUrls: ['../styles/widget-library.component.css'],
	templateUrl: '../views/widget-library.component.html'
})
export class WidgetLibraryComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}
}
